import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { BUDGET_LINE_ITEMS } from "./apiRoutes";

const mutateUpdateLineItem = async ({
  id,
  budgetId,
  data,
}: {
  id: string;
  budgetId: string;
  data: FieldValues;
}) => {
  return await axiosAuth.put(`${BUDGET_LINE_ITEMS(budgetId)}/${id}`, data);
};

const useUpdateLineItemMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
      budgetId: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateLineItem,
    ...queryParams,
  });

export default useUpdateLineItemMutation;
